import React, { Component } from 'react';
import PageHeader from 'components/enterprise/PageHeader';
import { routesBankAdmin } from 'routes/Routes';
import _validator from 'modules/validator';
import Button from 'components/controls/Button';

import _BankAdminServices from '../../modules/BankAdminServices';
import { Spin } from 'antd';
import _notification from 'modules/notification';
import { Card, Col, Row } from 'antd';
import MyInput from '../../components/controls/MyInput';
import moment from "moment";
import _utils from '../../modules/Utils';
import _authService from '../../modules/AuthService';
import { PROJECT_LOGO } from '../../constants/constants';


class CandidateDetails extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: null,
            loading: false,
            applicationID: "",
            applicationIDState: "",
            applicationIDError: "",
            transactionId: "",
            transactionIdState: "",
            confirmTransactionId: "",
            confirmTransactionIdState: "",
            transactionIdError: "",
            confirmTransactionIdError: ""
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        _authService.clearSessionHist();
    }

    //API operations
    getCandidateData = async (ev) => {
        try {
            ev.preventDefault();
            if (this.state.applicationIDState === "success") {

                this.setState({ loading: true }, async () => {
                    try {
                        let candidateData = await _BankAdminServices.GetCandidateData(this.state.applicationID);
                        //console.log("dashboardList Data: ", dashboardList.data);

                        if (candidateData.data.IsSuccess) {
                            this.setState({
                                ...this.state,
                                data: candidateData.data.Obj,
                                transactionId: "",
                                confirmTransactionId: "",
                                transactionIdState: '',
                                confirmTransactionIdState: '',
                                loading: false,
                            });
                        }
                        else {
                            this.setState({ loading: false, data: null, transactionId: "", transactionIdState: '', confirmTransactionId: "", confirmTransactionIdState: "" })
                            _notification.showMessage('error', candidateData.data.Message);
                        }


                    } catch (e) {
                        // TODO
                        this.setState({ loading: false, data: null, transactionId: "", transactionIdState: '', confirmTransactionId: "", confirmTransactionIdState: "" });
                        console.log('Error: ', e);
                    }
                });

            }
            else {
                if (this.state.applicationIDState === "") {
                    this.setState({ applicationIDState: "error", applicationIDError: "Invalid Application ID" });
                }
            }
        } catch (e) { }
    }

    updateCandidateTransactionID = async (ev) => {
        try {
            ev.preventDefault();
            if ((this.state.transactionId != "" && this.state.confirmTransactionId != "") &&
                (this.state.transactionId === this.state.confirmTransactionId)) {

                this.setState({ loading: true }, async () => {
                    try {
                        let candidateData = await _BankAdminServices.updateCandidateTransactionID({ ApplicationId: this.state.applicationID, Bank_Challan_Transaction_Id: this.state.transactionId });
                        //console.log("dashboardList Data: ", dashboardList.data);

                        if (candidateData.data.IsSuccess) {
                            _notification.showMessage('success', "Transaction ID updated successfully");
                            this.setState({
                                ...this.state,
                                data: "",
                                data: null,
                                transactionId: '',
                                confirmTransactionId: '',
                                applicationID: '',
                                transactionIdState: '',
                                confirmTransactionIdState: '',
                                loading: false,
                                transactionIdError: "",
                                confirmTransactionIdError: ""
                            });
                        }
                        else {
                            this.setState({ loading: false, data: null, transactionId: '', transactionIdState: '', confirmTransactionId: '', confirmTransactionIdState: '' })
                            _notification.showMessage('error', candidateData.data.Message);
                        }

                    } catch (e) {
                        // TODO
                        this.setState({ loading: false, data: null, transactionId: '', transactionIdState: '', confirmTransactionId: '', confirmTransactionIdState: '' });
                        console.log('Error: ', e);
                    }
                });

            }
            else {
                if (this.state.transactionId != this.state.confirmTransactionId) {
                    this.setState({
                        transactionIdState: "error",
                        confirmTransactionIdState: "error",
                        transactionIdError: <span style={{ width: "170px", display: "flex", color:"var(--color-error)" }}>Transaction ID and Confirm Transaction ID not matched</span>,
                        confirmTransactionIdError: <span style={{ width: "170px", display: "flex", color:"var(--color-error)" }}>Transaction ID and Confirm Transaction ID not matched</span>
                    });
                }

                if (this.state.transactionIdState === "") {
                    this.setState({ transactionIdState: "error", transactionIdError: "Invalid Transaction ID" });
                }

                if (this.state.confirmTransactionIdState === "") {
                    this.setState({ confirmTransactionIdState: "error", confirmTransactionIdError: "Invalid Confirm Transaction ID" });
                }
            }
        } catch (e) { }
    }

    onConfirmTransactionIDTextChange = ({ target: { name, value } }) => {
        switch (name) {
            case "confirmTransactionId":
                if (_validator.verifyBlank(value)) {
                    this.setState({
                        [name + "State"]: "success",
                        [name + "Error"]: "",
                    });
                } else {
                    this.setState({
                        [name + "State"]: "error",
                        [name + "Error"]: "Invalid Confirm Transaction ID"
                    });
                }
                break;

            default:
                this.setState({ [name + "State"]: "success" });
        }
        this.setState({ [name]: value, isLoginSuccess: "" });
    }

    onTextChange = ({ target: { name, value } }) => {
        switch (name) {
            case "applicationID":
                if (_validator.verifyBlank(value)) {
                    this.setState({
                        [name + "State"]: "success",
                        [name + "Error"]: ""
                    });
                } else {
                    this.setState({
                        [name + "State"]: "error",
                        [name + "Error"]: "Invalid Candidate ID"
                    });
                }
                break;

            case "transactionId":
                if (_validator.verifyBlank(value)) {
                    this.setState({
                        [name + "State"]: "success",
                        [name + "Error"]: ""
                    });
                } else {
                    this.setState({
                        [name + "State"]: "error",
                        [name + "Error"]: "Invalid Transaction ID"
                    });
                }
                break;

            // case "confirmTransactionId":
            // if (_validator.verifyBlank(value)) {
            // this.setState({
            // [name + "State"]: "success",
            // [name + "Error"]: ""
            // });
            // } else {
            // this.setState({
            // [name + "State"]: "error",
            // [name + "Error"]: "Invalid Confirm Transaction ID"
            // });
            // }
            // break;

            default:
                this.setState({ [name + "State"]: "success" });
        }
        this.setState({ [name]: value, isLoginSuccess: "" });
    }

    clearData = async (ev) => {
        this.setState({ applicationID: "", data: null });
    }

    preventCopyPaste = (e) => {
        e.preventDefault()
    }

    //const StudentPersonalInfo = () => {
    render() {
        return (
            <>

                <PageHeader
                    title="Candidate Verification Portal"
                    breadcrumbItems={[{ label: 'Bank Admin' }, { label: 'Candidate Verification Portal' }]}
                />
                <div className="wrap-back-admin ent-panel p-4 my-4  max1200 mx-auto  d-flex align-items-center justify-content-center flex-column">

                    <h4 className="heading4 mb-3">Candidate Verification Portal</h4>
                    <div className="topRow d-flex align-items-start w-100 justify-content-center">
                        <div className="backadmin-search mr-4">
                                <MyInput
                                        wrapClass="w-100 mb-0 hideLabel"
                                        key="applicationID"
                                        type="number"
                                        value={this.state.applicationID}
                                        name="applicationID"
                                        onChange={this.onTextChange}
                                        placeholder="Candidate Application ID / उमेदवाराचा अर्ज आयडी*"
                                        isRequired={true}
                                        errorState={this.state.applicationIDState}
                                        errorMessage={this.state.applicationIDError}
                                    />
                                    
                        </div>
                                <Button
                                    onClick={this.getCandidateData}
                                    className="button-global button-primary autoHeight small mr-4"
                                    style={{ height: '30px'}}
                                    value="Search"
                                ></Button>

                                <Button
                                    onClick={this.clearData}
                                    className="button-global button-secondary  autoHeight small"
                                    style={{ height: '30px'}}
                                    value="Clear"
                                ></Button>
                        
                                    
                    </div>

                </div>
                <div className="login-form-wrap position-relative w-100 align-items-center m-auto form-wrap d-flex align-items-center justify-content-center">
                    <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column">
                        
                        {this.state.data &&
                            
                            <div className="max1200 ent-panel">
                                <div className=" admin-inner-wrap p-3"> 
                                {this.state.loading && <Spin size="large" />}
                                    <table className='table_100_percent tableHiddenBorder' style={{ fontSize: '14px' }}>
                                        <tbody>
                                            <tr>
                                                <td className='table_personal_info_review' style={{ padding: 0, borderStyle: 'hidden' }}>
                                                    <table style={{ width: '100%' }}>
                                                        <tbody>
                                                            <tr>
                                                                <th>Applied Post</th>
                                                                <td>{(this.state.data.Applied_Post)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>Application Id</th>
                                                                <td>{(this.state.data.Application_Id)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>Full Name</th>
                                                                <td>{(this.state.data.First_Name) + ' ' +
                                                                    (this.state.data.Middle_Name) + ' ' +
                                                                    (this.state.data.Last_Name)}
                                                                </td>
                                                            </tr>
                                                            <tr className='hide' style={{ height: '25px' }}>
                                                                <th>Father's Name</th>
                                                                <td>{this.state.data.Father_Name}</td>
                                                            </tr>
                                                            <tr className='hide'>
                                                                <th> Mother's Name</th>
                                                                <td>{this.state.data.Mother_Name}</td>
                                                            </tr>
                                                            <tr>
                                                                <th> Mobile No.</th>
                                                                <td><span></span>{this.state.data.Mobile_Number}</td>
                                                            </tr>
                                                            <tr>
                                                                <th> Email Id</th>
                                                                <td>{this.state.data.Email}</td>
                                                            </tr>
                                                            <tr className='hide'>
                                                                <th>Address</th>
                                                                <td>
                                                                    <div>
                                                                        {this.state.data.Address}
                                                                    </div>
                                                                    <span>Village/City : </span>{this.state.data.Village}, { }
                                                                    <span>Taluka : </span>{this.state.data.Taluka}, { }
                                                                    <span>Dist : </span>{this.state.data.District}, { }
                                                                    <span>Pin Code : </span>{this.state.data.Pin_Code}, { }
                                                                    <span>State : </span>{this.state.data.State} { }
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th>Gender</th>
                                                                <td><span></span>{this.state.data.Gender}</td>
                                                            </tr>

                                                            <tr>
                                                                <td colSpan={2}>
                                                                    {/* <label style={{ marginRight: '10rem', display: 'inline', fontSize: '14px' }}><span>Gender :</span> {this.state.data.Gender}</label> */}
                                                                    <label style={{ fontSize: '14px', display: 'none' }}><span>Date Of Birth :</span>{moment(this.state.data.Birth_Date).format('DD-MMM-YYYY')}</label><br></br>
                                                                    <label style={{ fontSize: '14px', display: 'none' }}><span>Marital Status : </span>{this.state.data.Marital_Status}</label>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th style={{ verticalAlign: "top"}}>Transaction ID</th>
                                                                <td>
                                                                    <div className='w-100' style={{ display: 'flex', fontSize: '14px' }}>
                                                                        <MyInput
                                                                            wrapClass="w-50"
                                                                            key="transactionId"
                                                                            type="text"
                                                                            onCopy={(e) => this.preventCopyPaste(e)}
                                                                            onPaste={(e) => this.preventCopyPaste(e)}
                                                                            onCut={(e) => this.preventCopyPaste(e)}
                                                                            value={this.state.transactionId}
                                                                            name="transactionId"
                                                                            onChange={this.onTextChange}
                                                                            placeholder="Transaction Id"
                                                                            isRequired={true}
                                                                            maxlength={20}
                                                                            errorState={this.state.transactionIdState}
                                                                            errorMessage={this.state.transactionIdError}
                                                                        />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th style={{ minWidth: "160px", verticalAlign: "top"}}>Confirm Transaction ID</th>
                                                                <td>
                                                                    <div className='w-100' style={{ display: 'flex', fontSize: '14px' }}>
                                                                        <MyInput
                                                                            wrapClass="w-50"
                                                                            key="confirmTransactionId"
                                                                            type="password"
                                                                            onCopy={(e) => this.preventCopyPaste(e)}
                                                                            onPaste={(e) => this.preventCopyPaste(e)}
                                                                            onCut={(e) => this.preventCopyPaste(e)}
                                                                            value={this.state.confirmTransactionId}
                                                                            name="confirmTransactionId"
                                                                            onChange={this.onConfirmTransactionIDTextChange}
                                                                            placeholder="Confirm Transaction Id"
                                                                            isRequired={true}
                                                                            maxlength={20}
                                                                            errorState={this.state.confirmTransactionIdState}
                                                                            errorMessage={this.state.confirmTransactionIdError}
                                                                        />
                                                                        <Button
                                                                            onClick={this.updateCandidateTransactionID}
                                                                            type="submit" style={{ height: '30px', 'align-self': 'flex-start' }}
                                                                            className="button-global button-primary autoHeight small ml-3 mb-3 btn-green w-25"
                                                                            value="Update"
                                                                        ></Button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                           
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td style={{ borderStyle: 'hidden', display: "flex", marginLeft: "10px" }}>
                                                    <div className='candidate-photo'>
                                                        <div className='textAlignCenter'>
                                                            <img className={this.state.data.Profile_Pic_Path ? 'receipt_details_profile_img' : "receipt_details_profile_img hide"} src={this.state.data.Profile_Pic_Path ? this.state.data.Profile_Pic_Path : ""} alt="Profile" />
                                                        </div>
                                                        <div className='textAlignCenter'>
                                                            <img className={this.state.data.Signature_Path ? 'receipt_details_signature_img' : "receipt_details_signature_img hide"} src={this.state.data.Signature_Path ? this.state.data.Signature_Path : ""} alt="Signature" />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                        }
                    </div>

                </div>

                {this.state.loading && <Spin size="large" />}
            </>
        );
    };
}

export default CandidateDetails;
